import * as yup from 'yup';

export const initialValues = {
  name: '',
  restaurantName: '',
  city: '',
  phoneNumber: '',
  email: '',
};

export const validationSchema = yup.object().shape({
  name: yup.string().required('Name is required!'),
  restaurantName: yup.string().required('Restaurant is required!'),
  city: yup.string().required('City is required!'),
  phoneNumber: yup.string().required('Phone Number is required!'),
});
